<template>
  <v-form @submit.prevent="save">
    <v-container>
        <v-layout wrap>
            <v-flex xs12 md3>
              <v-text-field
                      v-validate="'required'"
                      v-model="employeeRole.name"
                      :error-messages="errors.first('name')"
                      :label="$t('Pages.EmployeeRoles.model.name')"
                      type="text"
                      color="indigo"
                      required
                      name="name"
              />
            </v-flex>
            <v-flex xs12 md3>
                <v-text-field
                        v-validate="'required'"
                        v-model="employeeRole.vacation_days"
                        :error-messages="errors.first('vacation_days')"
                        :label="$t('Pages.EmployeeRoles.model.vacation_days')"
                        type="number"
                        color="indigo"
                        min="0"
                        required
                        name="vacation_days"
                />
            </v-flex>
            <v-flex xs12 md12>
                <v-textarea
                        v-validate="'required'"
                        v-model="employeeRole.description"
                        :error-messages="errors.first('description')"
                        :label="$t('Pages.EmployeeRoles.model.description')"
                        type="text"
                        color="indigo"
                        required
                        name="description"
                />
            </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-btn round color="indigo" dark type="submit">
          {{$t('Core.Fields.save')}}
        </v-btn>
        <v-btn round href="javascript:history.go(-1)">
          {{$t('Core.Fields.back')}}
        </v-btn>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
    import Form from '../../services/Form'
    import _ from 'lodash';
export default {
  components: {},
  props: {
      employeeRole: {
          type: Object,
          required: true
      },
      edit: {
          type: Boolean,
          default: false
      }
  },
  data: () => ({
  }),
  computed: {
  },
  created () {

  },
  methods: {
      save(){
        this.$validator.validateAll().then((result) => {
            if (result) {
              let data = JSON.parse(JSON.stringify(this.employeeRole));
              this.$emit('save', data);
            }
        });
      }
  }
}
</script>

<style lang="scss">

</style>
